import { LicenseType } from "@shared-features/enums/license-type.enum";

export class BulkDriverWithTruck {
  fleetId: number;
  plateNumber: string;
  brand: string;
  brandId: number;
  truckType: string;
  truckTypeId: number;
  manufactureYear: number;
  sequenceNumber: number;
  ownerName: string;
  firstName: string;
  lastName: string;
  iqamaId: number;
  nonResidentId: number;
  mobileNumber: string;
  nationality: string;
  licenseType: LicenseType;
  licenseExpiry: Date|string;
  iqamaIdExpiry: Date|string;
  birthDate: Date|string;
  owner: string;
}

export class ValidatedBulkDriverWithTruck extends BulkDriverWithTruck {
  errors?: {property: string, messages: string[]}[];

  get exist(): boolean {
    /**
     * @todo: what makes the driver or truck is exist?
     */
    return !!this.errors && !!this.errors.find(err => err.messages.join(', ').includes('already exists'));
  }

  get duplicated(): boolean {
    return !!this.errors && !!this.errors.find(err => err.messages.join(', ').includes('duplicated'));
  }

  get failed(): boolean {
    return !!this.errors && !!this.errors.length;
  }
}
